import Vue from 'vue'
import Router from 'vue-router'
import login from '@/login'
import resource from '@/resource/index'
import content from '@/resource/content'
import exam from '@/resource/exam'
import vip from '@/vip/index'
import pack from '@/pack/index'
import packList from '@/pack/list'
import glossary from '@/pack/glossary'
import points from '@/points/index'
import badge from '@/badge/index'
import english from '@/resource/english'
import agreement from '@/mobile/agreement'
import grade from '@/grade/index'

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/resource',
      name: 'resource',
      component: resource,
      meta:{
        title:'资源管理'
      },
    },
    {
      path: '/content',
      name: 'content',
      component: content,
      meta:{
        title:'内容'
      },
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta:{
        title:'练习'
      },
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta:{
        title:'会员管理'
      },
    },
    {
      path: '/pack',
      name: 'pack',
      component: pack,
      meta:{
        title:'资源包会员管理'
      }
    },
    {
      path: '/packList',
      name: 'packList',
      component: packList,
      meta:{
        title:'资源包管理'
      }
    },
    {
      path: '/points',
      name: 'points',
      component: points,
      meta:{
        title:'积分管理'
      }
    },
    {
      path: '/badge',
      name: 'badge',
      component: badge,
      meta:{
        title:'徽章管理'
      }
    },
    {
      path: '/english',
      name: 'english',
      component: english,
      meta:{
        title:'英语'
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta:{
        title:'协议'
      }
    },
    {
      path: '/grade',
      name: 'grade',
      component: grade,
      meta:{
        title:'年级学期管理'
      }
    },
    {
      path: '/glossary',
      name: 'glossary',
      component: glossary,
      meta:{
        title:'词库管理'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js